/* Main sponsors — a deliberately small circle. Monochrome white logos
   on the dark surface; nothing competes with the brands. */

const SPONSORS = [
  { name: "DNB", logo: "/logos/dnb.svg", h: 30 },
  { name: "Claude", logo: "/logos/claude.svg", h: 34 },
  { name: "Equinor", logo: "/logos/equinor.svg", h: 52 },
];

export default function MainSponsors() {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="partners"
      data-testid="main-sponsors-section"
      className="section section-dark bg-[var(--dark)] text-[var(--bg)]"
    >
      <div className="max-w-page container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 md:mb-16">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="section-index">03</span>
              <span className="eyebrow eyebrow--accent" data-testid="sponsors-eyebrow">
                Main sponsors
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.98] tracking-[-0.02em] max-w-[18ch]">
              A small circle, by design.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 flex md:items-end">
            <p
              className="text-[14px] md:text-[15px] leading-[1.55] text-white/60 max-w-[38ch]"
              data-testid="sponsors-note"
            >
              Three main sponsors. Full-day presence, curated visibility,
              and a seat where the conversations happen.
            </p>
          </div>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 border-t border-white/15"
          data-testid="sponsors-grid"
        >
          {SPONSORS.map((s, i) => (
            <div
              key={s.name}
              className={`sponsor-cell flex items-center justify-center py-16 md:py-24 border-b border-white/15 md:border-b-0 ${
                i > 0 ? "md:border-l md:border-white/15" : ""
              }`}
              data-testid={`sponsor-cell-${i}`}
            >
              <img
                src={s.logo}
                alt={s.name}
                style={{ height: s.h }}
                className="sponsor-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        <div className="border-t border-white/15 pt-7 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[12px] tracking-[0.16em] uppercase text-white/40">
            One partner seat remains open for 2027
          </p>
          <a
            href="#partner-inquiry"
            onClick={scrollTo("partner-inquiry")}
            className="sponsor-link w-fit"
            data-testid="sponsors-cta"
          >
            Partner with us
            <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
